require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./journal-m-residence-poliform.json") })
        }
      }, "path---journal-m-residence-poliform");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---journal-m-residence-poliform!./.cache/json/journal-m-residence-poliform.json
// module id = 511
// module chunks = 231608221292675